import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
import laptopImage from "../assets/img/image-5.png";

const MainContentSection = () => {
  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#111111",
        py: 12,
        position: "relative",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              maxWidth: 456,
              mb: { xs: 4, md: 0 },
              mr: { xs: 0, md: 4 },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                color: "#fdfdfe",
                fontSize: "45px",
                lineHeight: "53px",
                fontWeight: 600,
                mb: 3,
                fontFamily: "'Outfit-SemiBold', Helvetica, Arial, sans-serif",
              }}
            >
              Remote IT Support Made Simple
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "#a4a3a1",
                fontSize: "15px",
                lineHeight: "25.5px",
                mb: 4,
              }}
            >
              Our team of experts provides comprehensive IT solutions for businesses of all sizes. We handle everything from routine maintenance to emergency troubleshooting, all without requiring on-site visits.
            </Typography>

            {/* <Button
              variant="contained"
              sx={{
                bgcolor: "white",
                color: "#848183",
                borderRadius: "10px",
                textTransform: "none",
                width: 187,
                height: 50,
                fontSize: "17px",
                fontWeight: "normal",
                "&:hover": {
                  bgcolor: "#f5f5f5",
                },
              }}
            >
              Get Started
            </Button> */}
          </Box>

          <Box
            component="img"
            src={laptopImage}
            alt="Person working on laptop"
            sx={{
              maxWidth: { xs: "100%", md: 719 },
              height: "auto",
              maxHeight: 548,
              objectFit: "cover",
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default MainContentSection;